const FaqData = [
    {
        question:"Whats my current CGPA?",
        answer: "9.22 GPA"
    },
    {
        question:"Which college and degree am I pursuing?",
        answer:"VIT Vellore, Btech IT 2023 Batch."
    },
    {
        question:"Whats my board results?",
        answer: "Class 10: 10 CGPA (CBSE) ; Class 12: 89% (CBSE)"
    },
    {
        question:"What projects have I worked on?",
        answer:"I have worked on various projects of web development in php, vanilla js, angularjs and now react. I am currently working on becoming a full stack developer MERN. I have also done a few ML supervized learning projects. The links to all can be found using the navigation above."
    },
    {
        question:"Have I ever worked before?",
        answer:"I was an intern for T4P for about 2 months where I worked in web development team to create a autoposter using PHP. For this role I worked with plenty of APIs such as Twitter, Linkedin and a little bit of Facebook."
    }
]

export default FaqData